import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Outlet, Link, redirect, useNavigate  } from "react-router-dom";
import appActions from '@app/redux/app/actions';
import LayoutStyles from './Layout/styles';
import {MenuFoldOutlined, MenuUnfoldOutlined, CaretDownOutlined, BankOutlined, PushpinOutlined, PushpinFilled, WarningOutlined} from '@ant-design/icons';
import TopbarNotification from './Layout/Topbar/TopbarNotification'
import TopbarMessage from './Layout/Topbar/TopbarMessage'
import TopbarUser from './Layout/Topbar/TopbarUser'
import { getAllCompanies, getCompaniesList } from '../apis/OdooApi';
import O2MLogo from '@app/assets/images/O2M-Logo.png'; 
// import Header from './Layout/Header';

import { Button, Layout, Menu, theme, Row, Col, Select, Spin,Typography, Space, Alert } from 'antd';
import { getEmitEnv } from '../apis/ConfiguracionAplicacionApi';
const { Text } = Typography;
const { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed } = appActions;

const { Sider, Content, Header, Footer } = Layout;
const App = ({ menuItems }) => {
  const dispatch = useDispatch();
	const { view, collapsed, openDrawer, current, height } = useSelector((state) => state.App);
  const {token: { colorBgContainer, borderRadiusLG }} = theme.useToken();
  const navigate = useNavigate();
  const [collapsed2, setCollapsed2] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState('1');
  const [companies, setCompanies] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(true);
  const [companyName, setCompanyName] = useState('');
  const hoverTimerRef = useRef(null);
  const [openKeys, setOpenKeys] = useState([]);
  const [savedOpenKeys, setSavedOpenKeys] = useState([]);
  const [isSiderPinned, setIsSiderPinned] = useState(false);
  const [emitEnv, setEmitEnv] = useState('');

  const items = menuItems;

  useEffect(() => {
    const loadEmitEnv = async () => {
      try {
        const response = await getEmitEnv();
        if (response.ok && response.payload) {
          setEmitEnv(response.payload.emit_env);
        }
      } catch (error) {
        console.error('Error al obtener el entorno de emisión:', error);
      }
    };
    loadEmitEnv();
  }, []);

  const onOpenChange = (keys) => {
    if (collapsed2) return;
    // Encontramos la llave que se acaba de intentar abrir
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    
    // Obtenemos todas las llaves de nivel superior
    const rootSubmenuKeys = items ? items.filter(i => i.children).map(i => i.key) : [];

    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      // Si la llave abierta es un hijo, mantenemos las llaves actuales
      setOpenKeys(keys);
    } else {
      // Si es una raíz o estamos cerrando, permitimos que AntD maneje el array de llaves
      // pero manteniendo la estructura de lo que queda abierto.
      setOpenKeys(latestOpenKey ? [latestOpenKey] : keys);
    }
  };
  // useEffect(() => {
  //   const fetchCompanies = async () => {
  //     try {
  //       setLoadingCompanies(true);
  //       const response = await getAllCompanies();
        
  //       if (response.ok && response.payload.length > 0) {
  //         const formattedCompanies = response.payload.map(company => ({
  //           value: company.id, // Usamos el ID interno como valor
  //           label: company.name, // Mostramos el nombre
  //           originalData: company // Guardamos todos los datos por si necesitamos algo más
  //         }));
          
  //         setCompanies(formattedCompanies);
  //         setSelectedCompany(formattedCompanies[0].value); // Selecciona la primera por defecto
  //       }
  //     } catch (error) {
  //       console.error("Error cargando compañías:", error);
  //     } finally {
  //       setLoadingCompanies(false);
  //     }
  //   };

  //   fetchCompanies();
  // }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem('currentUser');
    if (!storedUser || storedUser === 'undefined') {
      return;
    }

    try {
      const userData = JSON.parse(storedUser);
      if (userData && userData.companyName) {
        setCompanyName(userData.companyName);
      }
    } catch (error) {
      console.error('Error parsing currentUser from localStorage:', error);
      localStorage.removeItem('currentUser');
    }
  }, []);

  useEffect(() => {
    if (collapsed2) {
      const timer = setTimeout(() => {
        setOpenKeys([]);
      }, 200); 
      return () => clearTimeout(timer);
    }
  }, [collapsed2]);

  const handleToggleSiderPin = () => {
    if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);

    setIsSiderPinned((prev) => {
      const nextPinned = !prev;
      if (nextPinned) {
        setCollapsed2(false);
        setOpenKeys(savedOpenKeys);
      }
      return nextPinned;
    });
  };

  const handleCompanyChange = (value) => {
    setSelectedCompany(value);
    const selected = companies.find(c => c.value === value);
    console.log("Compañía seleccionada:", selected?.originalData);
    // Aquí puedes dispatchar una acción de Redux si necesitas guardar la compañía seleccionada globalmente
  };

  const menuCompanies = (
    <Menu>
      {companies.map((company) => (
        <Menu.Item key={company.key}>
          {company.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  function handleClick(e) {
		dispatch(changeCurrent([e.key]));
		if (view === 'MobileView') {
			setTimeout(() => {
				dispatch(toggleCollapsed());
				// dispatch(toggleOpenDrawer());
			}, 100);

			// clearTimeout(timer);
		}
	}

  const handleToggle = React.useCallback(() => dispatch(toggleCollapsed()), [
    dispatch
  ]);

  return (
    <LayoutStyles>
      <Layout style={{height:"100vh"}}>
        {emitEnv === 'dev' && (
          <Alert
            type="error"
            showIcon
            icon={<WarningOutlined style={{ color: '#fff' }} />}
            banner
            message={
              <span style={{ color: '#fff', fontWeight: 600, fontSize: 11 }}>
                Entorno de desarrollo: los timbrados y el envío de correos son de prueba
              </span>
            }
            style={{
              backgroundColor: '#e04a00',
              borderRadius: 0,
              height: 16,
              fontSize: 11,
            }}
          />
        )}
        <Header>
          <Row style={{paddingRight: 20}}>
            <Col flex={2}>
            <div className="logo">
              {/* <img alt="altregy" src={"https://altregy.com/img/Logo/LOGO-ALTREGY@2x.png"} style={{maxWidth: 90}}/> */}
              <img alt="o2m" src={O2MLogo} style={{maxWidth: 150, marginLeft: -30}}/>
            </div>
              {/* <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={handleToggle}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              /> */}
            </Col>
            <Col flex={3} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '15px' }}>
            {companyName && (
                <Space style={{ marginRight: 16 }}>
                  <BankOutlined />
                  <Text strong style={{ color: 'black' }}>{companyName}</Text>
                </Space>
              )}
              {/* <TopbarNotification /> */}
              <TopbarUser />
              
              {/* <TopbarMessage /> */}
            </Col>
          </Row>
        </Header>
        <Layout>
          <Sider 
              width={250}
              collapsedWidth={64}
              collapsed={collapsed2}
              onMouseEnter={() => {
                if (isSiderPinned) return;
                if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
                hoverTimerRef.current = setTimeout(() => {
                  setCollapsed2(false);
                  setOpenKeys(savedOpenKeys);
                }, 100);
              }}
              onMouseLeave={() => {
                if (isSiderPinned) return;
                if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
                hoverTimerRef.current = setTimeout(() => {
                  setSavedOpenKeys(openKeys);
                  setOpenKeys([]);
                  setCollapsed2(true);
                }, 500);
              }}
              style={{
                borderRight: '#e9e9e9 solid 0.5px',
                position: 'fixed',
                top: emitEnv === 'dev' ? 80 : 64,
                left: 0,
                height: emitEnv === 'dev' ? 'calc(100vh - 80px)' : 'calc(100vh - 64px)',
                zIndex: 9,
              }}>
          <div className="sider-pin-toggle">
            <Button
              type="text"
              className={isSiderPinned ? 'is-pinned' : ''}
              icon={isSiderPinned ? <PushpinFilled /> : <PushpinOutlined />}
              onClick={handleToggleSiderPin}
              title={isSiderPinned ? 'Desanclar menu' : 'Anclar menu'}
            />
          </div>
                
          <Menu
            onClick={(item) => navigate("" + item.key)}
            theme="light"
            mode="inline"
            triggerSubMenuAction="hover"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            items={items}
          />

          </Sider>
            <Layout style={{
              marginLeft: collapsed2 ? 64 : 250,
              transition: 'margin-left 0.3s ease',
            }}>
              {/* An <Outlet> renders whatever child route is currently active,
              so you can think about this <Outlet> as a placeholder for
              the child routes we defined above. */}
              <Content style={{
                  padding: 24,
                  margin: 0,
                  minHeight: 280,
                  // background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                }}>
                  <Outlet />
              </Content>
              <Footer
                  style={{
                    textAlign: 'center',
                  }}
                >
                One2Many ©{new Date().getFullYear()} - Todos los derechos reservados
              </Footer>
            </Layout>
        </Layout>
      </Layout>
    </LayoutStyles>
  );
};
export default App;